<template>
    <v-container>
      <!-- 頂部操作列 -->
      <div class="d-flex align-center mb-6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="請輸入姓名或系所或教師資料"
          outlined
          dense
          hide-details
          class="flex-grow-1 mr-4"
        ></v-text-field>
        
        <v-btn
          color="black"
          dark
          class="mr-2"
          @click="downloadCSV"
        >
          下載CSV
        </v-btn>
        
        <v-btn
          color="black"
          dark
          @click="addTeacher"
        >
          新增帳號
        </v-btn>
      </div>
  
      <!-- 教師列表 -->
      <div v-for="(group, index) in filteredTeacherGroups" :key="index">
        <div class="d-flex align-center my-4">
          <div class="text-h6 font-weight-bold text-left">{{ group.departmentName }}</div>
          <v-divider class="flex-grow-1 ml-2"></v-divider>
        </div>
        
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>姓名</th>
                <th>帳號</th>
                <th>密碼</th>
                <th>信箱</th>
                <th class="text-right">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="teacher in group.teachers" :key="teacher.id">
                <td class="text-left">{{ teacher.name }}</td>
                <td class="text-left">{{ teacher.username }}</td>
                <td class="text-left">{{ teacher.password }}</td>
                <td class="text-left">{{ teacher.email }}</td>
                <td class="text-right">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editTeacher(teacher)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteTeacher(teacher)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
  
      <!-- Add this dialog component -->
      <v-dialog v-model="deleteDialog" max-width="300">
        <v-card>
          <v-card-title class="text-h6">
            確定刪除帳號嗎?
             </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="deleteDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="error"
              text
              @click="confirmDelete"
            >
              刪除
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Add Account Dialog -->
      <v-dialog v-if="addDialog" v-model="addDialog" max-width="1000">
        <v-card>
          <v-card-title class="text-h6">
            選擇學校及系所資訊
          </v-card-title>
          
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="newAccount.school.name"
                  label="學校"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="newAccount.department"
                  :items="departmentsList"
                  label="系別"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>

            <v-row align="center" class="mb-4">
              <v-col cols="2">
                <v-btn small icon @click="decrementCount">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="accountCount"
                  type="number"
                  outlined
                  dense
                  hide-details
                  disabled
                  class="text-center"
                  @change="initializeNewAccounts"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn small icon @click="incrementCount">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>帳號</th>
                    <th>密碼</th>
                    <th>信箱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in parseInt(accountCount)" :key="i">
                    <td class="text-left">{{ newAccounts[i-1].name }}</td>
                    <td class="text-left">{{ newAccounts[i-1].username }}</td>
                    <td class="text-left">{{ newAccounts[i-1].password }}</td>
                    <td class="text-left">{{ newAccounts[i-1].email }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="closeAddDialog"
            >
              取消
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="confirmAdd"
            >
              新增
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Success Dialog -->
      <v-dialog v-model="successDialog" max-width="300">
        <v-card>
          <v-card-title class="text-h6 justify-center">
            新增帳號成功
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="black"
              text
              @click="successDialog = false"
            >
              完成
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="downloadAddedCSV"
            >
              下載CSV檔
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Edit Teacher Dialog -->
      <v-dialog v-model="editDialog" max-width="1000">
        <v-card class="pa-6">
          <!-- Header Section -->
          <div class="d-flex align-center mb-8">
            <div>
              <div class="text-h5 font-weight-bold text-left">編輯教師資料</div>
              <div class="text-subtitle-1 grey--text text-left">{{ editingTeacher.department.name }}</div>
            </div>
            <v-spacer></v-spacer>
          </div>

          <!-- Profile Form -->
          <v-form>
            <v-row>
              <!-- 姓名 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingTeacher.name" label="姓名" outlined></v-text-field>
              </v-col>
              <!-- 帳號 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingTeacher.username" label="帳號" outlined></v-text-field>
              </v-col>
              <!-- 密碼 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingTeacher.password" label="密碼" outlined></v-text-field>
              </v-col>
              <!-- 信箱 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingTeacher.email" label="信箱" outlined></v-text-field>
              </v-col>
              <!-- 電話 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingTeacher.phone" label="電話" outlined></v-text-field>
              </v-col>
              <!-- 性別 -->
              <v-col cols="12" md="4">
                <v-select v-model="editingTeacher.sex" :items="sexOptions" label="性別" outlined></v-select>
              </v-col>
              <!-- 學校 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="newAccount.school.name" label="學校" outlined readonly></v-text-field>
              </v-col>
              <!-- 系所 -->
              <v-col cols="12" md="4">
                <v-select
                  v-model="editingTeacher.department"
                  :items="departmentsList"
                  label="系所"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="black" dark height="44" @click="confirmEdit"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
        </v-card>
      </v-dialog>
      
    </v-container>
  </template>
  
  <script>
  import userService from '../../services/user.service'
  import departmentService from '../../services/department.service'
  export default {
    name: 'TeacherList',
    data() {
      return {
        search: '',
        teacherGroups: [
        ],
        deleteDialog: false,
        teacherToDelete: null,
        addDialog: false,
        departmentsList: [],
        accountCount: 10,
        newAccount: {
          school: '',
          department: '',
        },
        newAccounts: [],
        successDialog: false,
        addedCSV: [],
        editDialog: false,
        editingTeacher: {
          name: '',
          username: '',
          password: '',
          email: '',
          phone: '',
          sex: '',
          department: {name:''}
        },
        sexOptions:['男','女','其他']
      }
    },
    async mounted() {
      await this.getUserInfo();
      await this.getTeacherBySchool();
    },
    methods: {
      async getTeacherBySchool() {
        const response = await userService.getTeacherBySchool();
        console.log(response.data);
        this.teacherGroups = response.data;
      },
      async getUserInfo() {
        const response = await userService.getUserInfo(localStorage.getItem('user_id'));
        this.newAccount.school = response.data.school;
      },
      async getDepartments() {
        const response = await departmentService.getDepartmentsBySchool();
        this.departmentsList = response;
      },
      async addTeacher() {
        await this.getDepartments();
        this.addDialog = true;
        this.initializeNewAccounts();
      },
      initializeNewAccounts() {
        this.newAccounts = Array(parseInt(this.accountCount)).fill().map(() => ({
          name: '',
          username: this.randomAccount(),
          password: this.randomPassword(),
          email: ''
        }));
      },
      randomAccount() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      },
      randomPassword() {
        return Math.random().toString(36).substring(2, 15);
      },
      incrementCount() {
        this.accountCount = parseInt(this.accountCount) + 1;
        this.initializeNewAccounts();
      },
      decrementCount() {
        if (this.accountCount > 1) {
          this.accountCount = parseInt(this.accountCount) - 1;
          this.initializeNewAccounts();
        }
      },
      closeAddDialog() {
        this.addDialog = false;
        this.newAccount.department='';
        this.initializeNewAccounts();
      },
      confirmAdd() {
        if(this.newAccount.department===''||this.newAccount.department===null){
          return alert('請選擇系所');
        }
        // 保存要下載的資料
        this.addedCSV = {
          school: this.newAccount.school,
          department: this.newAccount.department,
          accounts: [...this.newAccounts]  // 創建深拷貝
        };
        
        userService.addTeacherBySchool(this.newAccount,this.newAccounts)
        .then(() => {
          this.closeAddDialog();
          this.successDialog=true;
          this.getTeacherBySchool();
        })
        .catch(err => {
          console.log(err)
          alert(err.message)
        });
      },
      downloadAddedCSV() {
        // 使用保存的資料
        const headers = ['學校', '系所', '姓名', '帳號', '密碼', '信箱'];
        let csvContent = headers.join(',') + '\n';
        
        this.addedCSV.accounts.forEach(account => {
          const row = [
            this.addedCSV.school.name,
            this.addedCSV.department.name,
            account.name,
            account.username,
            account.password,
            account.email
          ].join(',');
          csvContent += row + '\n';
        });
        
        this.downloadFile(csvContent, '新增帳號.csv');
      },
      downloadCSV() {
        // 準備 CSV 內容
        const headers = ['學校', '系所', '姓名', '帳號', '密碼', '信箱'];
        let csvContent = headers.join(',') + '\n';
        
        // 將所有教師群組的資料合併
        this.teacherGroups.forEach(group => {
          group.teachers.forEach(teacher => {
            const row = [
              this.newAccount.school.name,
              teacher.department.name,
              teacher.name,
              teacher.username,
              teacher.password,
              teacher.email
            ].join(',');
            csvContent += row + '\n';
          });
        });
        
        this.downloadFile(csvContent, '教師資料.csv');
      },
      editTeacher(teacher) {
        this.editingTeacher = teacher;
        this.getDepartments(); // 獲取系所列表
        this.editDialog = true;
      },
      deleteTeacher(teacher) {
        this.teacherToDelete = teacher;
        this.deleteDialog = true;
      },
      confirmDelete() {
        // Implement your delete logic here
        userService.deleteTeacher(this.teacherToDelete).then(()=>{
          this.getTeacherBySchool();
        });
        console.log('Deleting teacher:', this.teacherToDelete);
        
        // Close the dialog
        this.deleteDialog = false;
        this.teacherToDelete = null;
      },
      downloadFile(content, fileName) {
        // 添加 BOM 以確保 Excel 正確顯示中文
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + content], { type: 'text/csv;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      async confirmEdit() {
        if(this.editingTeacher.username === '') {
          alert('帳號不能為空')
          return
        }
        if(this.editingTeacher.password === '') {
          alert('密碼不能為空')
          return
        }
        try {
          await userService.updateTeacher(this.editingTeacher);
          await this.getTeacherBySchool(); // 重新獲取教師列表
          this.editDialog = false;
        } catch (error) {
          console.error('更新失敗:', error);
          alert('更新失敗，請稍後再試');
        }
      }
    },
    computed: {
      filteredTeacherGroups() {
        if (!this.search) {
          return this.teacherGroups;
        }

        const searchTerm = this.search.toLowerCase().trim();
        
        return this.teacherGroups.filter(group => {
          // 檢查該系所下的教師是否有符合搜尋條件的
          const hasMatchingTeachers = group.teachers.some(teacher => 
            // 搜尋教師姓名
            teacher.name?.toLowerCase().includes(searchTerm) ||
            // 搜尋系所名稱
            teacher.department?.name?.toLowerCase().includes(searchTerm) ||
            // 搜尋教師信箱
            teacher.email?.toLowerCase().includes(searchTerm)
          );

          return hasMatchingTeachers;
        }).map(group => ({
          ...group,
          // 只保留符合搜尋條件的教師
          teachers: group.teachers.filter(teacher =>
            teacher.name?.toLowerCase().includes(searchTerm) ||
            teacher.department?.name?.toLowerCase().includes(searchTerm) ||
            teacher.email?.toLowerCase().includes(searchTerm)
          )
        }));
      }
    }
  }
  </script>
  
  <style scoped>
  .v-data-table ::v-deep th {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
  
  .v-data-table ::v-deep td {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  
  .v-icon {
    cursor: pointer;
  }
  
  .v-icon:hover {
    opacity: 0.7;
  }
  
  .v-text-field ::v-deep .v-input__slot {
    background-color: #f5f5f5 !important;
  }
  </style> 